var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33468 21.8891V15.8549C6.33468 15.2893 6.79586 14.8307 7.36476 14.8307H9.42492C9.99382 14.8307 10.455 15.2893 10.455 15.8549V21.8891M10.455 10.9758C10.455 11.5415 9.99382 12 9.42492 12H7.36476C6.79586 12 6.33468 11.5415 6.33468 10.9758C6.33468 10.4102 6.79586 9.95165 7.36476 9.95165H9.42492C9.99382 9.95165 10.455 10.4102 10.455 10.9758ZM10.455 6.36704C10.455 6.93267 9.99382 7.39121 9.42492 7.39121H7.36476C6.79586 7.39121 6.33468 6.93267 6.33468 6.36704C6.33468 5.8014 6.79586 5.34286 7.36476 5.34286H9.42492C9.99382 5.34286 10.455 5.8014 10.455 6.36704ZM13.9023 17.9033V15.8549C13.9023 15.2893 14.3635 14.8307 14.9324 14.8307H16.9926C17.5615 14.8307 18.0227 15.2893 18.0227 15.8549V17.9033H13.9023ZM13.7675 10.2176V3C13.7675 2.44772 13.3198 2 12.7675 2L6 2C4.34315 2 3 3.34315 3 5V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13.2176C21 12.113 20.1046 11.2176 19 11.2176H14.7675C14.2152 11.2176 13.7675 10.7699 13.7675 10.2176Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.8880c5eff8c01308419ff0ebb8360fe3.svg";
export { ForwardRef as ReactComponent };